import { getToken, onMessage } from "firebase/messaging";
import config from "../config";
import INTOUCH_API from "../services/Api";
import { messaging } from "../initialize-firebase";
import { useEffect } from "react";
import { isPWA, isWebView } from "../utils/helpers";
import * as Sentry from "@sentry/react";
import useModalActions from "./useModalActions";
import { MODAL_TYPES } from "../utils/emitter";

export default function useFirebaseWebNotification() {
  const { openModal } = useModalActions();
  async function connectFirebaseWebNotification() {
    try {
      if (isWebView()) return;
      if (
        typeof Notification !== "undefined" &&
        Notification.permission === "granted"
      ) {
        const worker = await registerWorker();
        return await saveToken(worker);
      } else {
        console.log("Not granted permission");
      }
    } catch (err) {
      console.log("Token error:", err);
      Sentry.captureException(err, {
        tags: {
          feature: "firebase_notifications",
          component: "useFirebaseWebNotification",
        },
        level: "warning",
      });
    }
  }

  async function registerWorker() {
    try {
      return await navigator.serviceWorker.register(
        "/game/firebase-messaging-sw.v8.js"
      );
    } catch (e) {
      console.log(e);
      Sentry.captureException(e, {
        tags: {
          feature: "firebase_notifications",
          component: "useFirebaseWebNotification",
        },
        level: "warning",
      });
    }
  }

  async function saveToken(workerRegistration) {
    const token = await getToken(messaging, {
      vapidKey: config.vapidKey,
      serviceWorkerRegistration: workerRegistration,
    });
    await INTOUCH_API.requestManager(
      "save_fcm_web",
      { webDeviceToken: token },
      (response) => {
        console.log(response);
      },
      (err) => {
        console.log(err);
        Sentry.captureException(err, {
          tags: {
            feature: "save_fcm_web",
            component: "useFirebaseWebNotification",
          },
          level: "warning",
        });
      }
    );
    return token;
  }

  useEffect(() => {
    // messaging нет, если браузер не поддерживает FCM (iOS Safari) или ?diag=nofb
    if (!("serviceWorker" in navigator) || isWebView() || !messaging) return;
    const unsubscribe = onMessage(messaging, async (payload) => {
      console.log("Message received in foreground:", payload);

      const { title, body, link } = payload.data;

      if (Notification.permission === "granted" && title) {
        const reg = await navigator.serviceWorker.getRegistration();
        if (reg) {
          reg.showNotification(title, {
            body,
            icon: "/game/icon-192x192.png",
            data: {
              link: link,
            },
          });
        } else {
          new Notification(title, {
            body,
            icon: "/game/icon-192x192.png",
            data: {
              link: link,
            },
          });
        }
      }
    });

    return () => unsubscribe();
  }, []);

  return {
    connectFirebaseWebNotification,
  };
}
